var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2212 15.7354V21.5688C26.2212 21.9479 26.2066 22.3125 26.1628 22.6625C25.8274 26.6 23.5087 28.5541 19.2357 28.5541H18.6524C18.2878 28.5541 17.9378 28.7292 17.7191 29.0208L15.9691 31.3542C15.1962 32.3896 13.942 32.3896 13.1691 31.3542L11.4191 29.0208C11.2295 28.7729 10.8066 28.5541 10.4857 28.5541H9.90242C5.25034 28.5541 2.91699 27.4021 2.91699 21.5688V15.7354C2.91699 11.4625 4.88575 9.14376 8.80867 8.80835C9.15867 8.7646 9.52325 8.75 9.90242 8.75H19.2357C23.8878 8.75 26.2212 11.0833 26.2212 15.7354Z",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0544 9.90144V15.7348C32.0544 20.0223 30.0857 22.3264 26.1628 22.6619C26.2065 22.3119 26.2211 21.9473 26.2211 21.5681V15.7348C26.2211 11.0827 23.8878 8.74935 19.2357 8.74935H9.90234C9.52318 8.74935 9.15859 8.76394 8.80859 8.80769C9.14401 4.88478 11.4628 2.91602 15.7357 2.91602H25.069C29.7211 2.91602 32.0544 5.24936 32.0544 9.90144Z",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6806 19.3229H19.6937",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5771 19.3229H14.5902",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4726 19.3229H9.48573",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesContact);
export default __webpack_public_path__ + "static/media/messages_contact.c597a74045ce6aad2a04240bd28c28b8.svg";
export { ForwardRef as ReactComponent };